import { getOptimizelyProjectId as getOptimizelyProjectIdBase } from '@change-corgi/config/optimizely';
import type { EnvironmentUtils } from '@change-corgi/core/environment';
import type { EventTracker } from '@change-corgi/core/eventTracker';
import type { Optimizely } from '@change-corgi/core/optimizely';
import { createOptimizely as _createOptimizely } from '@change-corgi/core/optimizely';

import type { SessionConfiguration } from '#src/shared/session';

type Options = Readonly<{
	environment: EnvironmentUtils;
	sessionConfiguration: SessionConfiguration;
}>;

function getOptimizelyProjectId(environment: EnvironmentUtils): string {
	return getOptimizelyProjectIdBase(environment.getEnvironment()) || getOptimizelyProjectIdBase('development');
}

export function createOptimizely({ environment, sessionConfiguration }: Options): Optimizely {
	return _createOptimizely({
		projectId: getOptimizelyProjectId(environment),
		enabled: sessionConfiguration.featureConfigs.optimizelyEnabled,
		eventSafelist: sessionConfiguration.featureConfigs.optimizelyEventSafelist,
		propertySafelist: sessionConfiguration.featureConfigs.optimizelyPropertySafelist,
	});
}

type InitOptions = Readonly<{
	tracker: EventTracker;
}>;

// this is needed because tracker depends on optimizely, and optimizely depends on tracker
export function initOptimizely(optimizely: Optimizely, { tracker }: InitOptions): Optimizely {
	return optimizely.setTrack(tracker.track.bind(tracker)).init();
}
